import { message, Modal } from 'ant-design-vue';
import Markdown from '@tencent/ui-core/lib/builtin/components/Markdown';
export function getMessageSpy(_state) {
  // 这里的h必须保留,不然编译后会报错
  // @ts-ignore
  const renderModalContent = h => {
    const MDComp = Markdown;
    const doc = `
假设接口的错误码字段是ret,错误消息是msg,和代码逻辑不一样

#### 方法一：修改方法内的前端逻辑

<img src="https://vfiles.gtimg.cn/wuji_material/mn54a6gy0a.png" width="400"/> 
<span style="font-size:24px;">&rarr;</span>
<img src="https://vfiles.gtimg.cn/wuji_material/rbqps8t7qzo.png" width="400"/>

#### 方法二: 后端响应修剪,对齐code,message字段

<img src="https://vfiles.gtimg.cn/wuji_material/011khbrcy85fo.png" width="800"/>
`;
    return h("div", [h(MDComp, {
      "attrs": {
        "source": doc
      }
    })]);
  };
  const messageSpy = new Proxy(message, {
    get(target, key) {
      if (key === 'error') {
        return function (...args) {
          if ((args === null || args === void 0 ? void 0 : args[0]) === undefined) {
            const res = Modal.warning({
              title: '错误信息为[undefined]，可能原因：你的错误码定义可能和方法代码逻辑不一致，可以通过以下几种方法解决',
              content: renderModalContent,
              width: 1000,
              dialogStyle: {},
              keyboard: false,
              onCancel: () => res.destroy(),
              onOk: () => res.destroy()
            });
          }
          // @ts-ignore
          return target.error(...args);
        };
      }
      return target[key];
    }
  });
  return messageSpy;
}
//# sourceMappingURL=getMessageSpy.js.map
